import type { AxiosResponse } from "axios";
import { wooRestApi } from "@/api/clients/wooRestApiClient";
import type { GetCategoryListRequestParams } from "@/types/api/wooRestApi";
import type { ProductCategory } from "@/types/productCategory";
import type { ProductVariation } from "@/types/productVariations";
import type { PaymentGateway } from "@/types/payments";

const wooRestApiService = {
  product: {
    categories: {
      getAll: async (params?: GetCategoryListRequestParams, signal?: AbortSignal) => {
        try {
          const response = await wooRestApi.get("/v3/products/categories", {
            params,
            signal,
          });
          return response as AxiosResponse<ProductCategory[]>;
        } catch (error) {
          throw error;
        }
      },
    },
  },

  productVariations: {
    get: async (productId: string, params?: Record<string, any>, signal?: AbortSignal) => {
      try {
        const response = await wooRestApi.get(`/v3/products/${productId}/variations`, {
          params,
          signal,
        });
        return response as AxiosResponse<ProductVariation[]>;
      } catch (error) {
        throw error;
      }
    },
  },

  paymentGateways: {
    getAll: async (signal?: AbortSignal) => {
      try {
        const response = await wooRestApi.get("/v3/payment_gateways", {
          signal,
        });
        return response as AxiosResponse<PaymentGateway[]>;
      } catch (error) {
        throw error;
      }
    },
  },
};

export default wooRestApiService;
